import { render, staticRenderFns } from "./permission-users.vue?vue&type=template&id=38b46ad6&scoped=true&"
import script from "./permission-users.vue?vue&type=script&lang=js&"
export * from "./permission-users.vue?vue&type=script&lang=js&"
import style0 from "./permission-users.vue?vue&type=style&index=0&id=38b46ad6&lang=scss&scoped=true&"
import style1 from "./permission-users.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b46ad6",
  null
  
)

export default component.exports